// extracted by mini-css-extract-plugin
export var content = "PreviewBlog-module--content--fe079";
export var list = "PreviewBlog-module--list--39773";